var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{class:{
    'text--disabled': true,
  },attrs:{"bottom":"","color":"font","disabled":!_vm.isContentWrapped},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
return [_c('span',_vm._g({},on),[_c('data-input',{attrs:{"data-type":_vm.dataType,"rules":_vm.rules,"disabled":_vm.disabled},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)]}}])},[_vm._v(" "+_vm._s(_vm.computedValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }